import Router from "@/router/router";
import * as Sentry from "@sentry/react";
import ReactQueryProvider from "./providers/ReactQueryProvider";

function App() {
  return (
    <Sentry.ErrorBoundary>
      <ReactQueryProvider>
        <Router />
      </ReactQueryProvider>
    </Sentry.ErrorBoundary>
  );
}

export default App;
